const java = `
package org.socket;

import java.io.ByteArrayInputStream;
import java.io.IOException;
import java.util.Timer;
import java.util.TimerTask;
import java.util.zip.GZIPInputStream;

import org.java_websocket.client.WebSocketClient;
import org.java_websocket.handshake.ServerHandshake;
import org.java_websocket.enums.ReadyState;

import java.net.URI;
import java.nio.ByteBuffer;

public class WebSocketExample {
    private static final String PATH = "wss://open-api-swap.bingx.com/swap-market?listenKey=425f783f4a17cd65f4a5d7470cfd45a956dba0c29564aa4b70967bee4e4a8984";
    private static final String CHANNEL = "https://open-api.bingx.com/openApi/user/auth/userDataStream";
    private static WebSocketClient webSocketClient;

    public static void main(String[] args) {
        try {
            // Initialize WebSocket client
            URI uri = new URI(PATH);
            webSocketClient = new WebSocketClient(uri) {
                @Override
                public void onOpen(ServerHandshake handshakedata) {
                    System.out.println("WebSocket connection opened");
                    send(CHANNEL);
                }

                @Override
                public void onMessage(String message) {
                    System.out.println("Received Text Message: " + message);
                }

                @Override
                public void onMessage(ByteBuffer bytes) {
                    try {
                        String decodedMsg = decodeGzip(bytes.array());
                        System.out.println("Received Binary Message: " + decodedMsg);

                        if ("Ping".equals(decodedMsg)) {
                            send("Pong");
                            System.out.println("Sent Pong");
                        }

                    } catch (IOException e) {
                        System.out.println("Error decoding message: " + e.getMessage());
                    }
                }

                @Override
                public void onClose(int code, String reason, boolean remote) {
                    System.out.println("WebSocket connection closed: " + reason);
                }

                @Override
                public void onError(Exception ex) {
                    System.out.println("WebSocket error: " + ex.getMessage());
                }
            };

            webSocketClient.connectBlocking();

            // Schedule periodic ping messages
            Timer timer = new Timer();
            timer.schedule(new TimerTask() {
                @Override
                public void run() {
                    if (webSocketClient.getReadyState() == ReadyState.OPEN) {
                        webSocketClient.send("Ping");
                        System.out.println("Sent Ping");
                    }
                }
            }, 0, 5000);

        } catch (Exception e) {
            e.printStackTrace();
        }
    }

    // GZIP decoding function
    private static String decodeGzip(byte[] compressedData) throws IOException {
        GZIPInputStream gzipInputStream = new GZIPInputStream(new ByteArrayInputStream(compressedData));
        byte[] buffer = new byte[1024];
        StringBuilder decodedMessage = new StringBuilder();

        int len;
        while ((len = gzipInputStream.read(buffer)) != -1) {
            decodedMessage.append(new String(buffer, 0, len));
        }

        gzipInputStream.close();
        return decodedMessage.toString();
    }
}
`
export default java


// WEBPACK FOOTER //
// ./src/utils/codeWs/java.js